export default __webpack_public_path__ + "static/media/projector.1aa6d42b.svg";